import { Images } from '@/assets/images';
const { LogoWithText, LogoWithoutText } = Images;

interface LogoProps {
  collapsed?: boolean;
}

export const Logo = ({ collapsed }: LogoProps) => {
  if (collapsed) {
    return (
      <LogoWithoutText
        role="img"
        aria-label="Kirin Logo"
        className="fill-foreground flex-shrink-0 relative -left-[3.5px] h-[29px] w-auto"
      />
    );
  }
  return (
    <LogoWithText
      role="img"
      aria-label="Kirin Logo"
      className="fill-foreground flex-shrink-0 h-24 w-auto"
    />
  );
};
